import { render, staticRenderFns } from "./Forwarder.vue?vue&type=template&id=4c8d55c6"
import script from "./Forwarder.vue?vue&type=script&lang=js"
export * from "./Forwarder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports